import { Box } from "@mui/material"
import PathHintsTracker, { PathHintsTrackerProps } from "../hints/PathHintsTracker"


interface ReworkPathTrackerProps extends PathHintsTrackerProps{
    top: number,
    left: number,
}
const ReworkPathTracker = (props: ReworkPathTrackerProps) => {

    return <Box position={"absolute"} top={props.top} left={props.left}>
        <PathHintsTracker {...props} />
    </Box>
}

export default ReworkPathTracker